var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckedButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 40,
    viewBox: "0 0 76 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H68C72.4183 0 76 3.58172 76 8V32C76 36.4183 72.4183 40 68 40H8C3.58172 40 0 36.4183 0 32V8Z",
    fill: "#00AD7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 4C29.1757 4 22 11.1757 22 20C22 28.8243 29.1757 36 38 36C46.8243 36 54 28.8243 54 20C54 11.1757 46.8243 4 38 4Z",
    fill: "#008766"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0656 14.3738L35.498 22.9372L31.6647 19.1039C31.1708 18.61 30.3645 18.61 29.8705 19.1039C29.3765 19.5979 29.3765 20.4042 29.8705 20.8982L34.6007 25.6284C34.8496 25.8773 35.1738 26 35.4977 26C35.8219 26 36.1458 25.8776 36.3947 25.6284L45.8592 16.1674C46.3532 15.6734 46.3532 14.8671 45.8592 14.3732C45.3611 13.8753 44.5596 13.8757 44.0656 14.3738Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedButton);
export default __webpack_public_path__ + "static/media/checked_button.d7bc82df2005ea4cc5b266be76443136.svg";
export { ForwardRef as ReactComponent };